import SearchBoxFilter from './SearchBoxFilter'

export default SearchBoxFilter
